angular.module("dx.webapp.cookies", ["ngCookies"]);
